var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-invoice" }, [
    _c("table", [
      _c("thead", { staticClass: "table-invoice__thead" }, [
        _c("tr", [
          _c("th", { staticClass: "table-invoice__th table-invoice__th--id" }, [
            _c(
              "div",
              {
                staticClass:
                  "table-invoice__info-wrapper table-invoice__info-wrapper--pointer",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeSort("manufacturer")
                  }
                }
              },
              [
                _c(
                  "text-bemto",
                  {
                    attrs: {
                      fw: "bold",
                      lh: "small",
                      fs: "xs",
                      color: "black",
                      tag: "p"
                    }
                  },
                  [_vm._v("MANUFACTURER")]
                ),
                _c("div", {
                  staticClass: "table-invoice__icon icon icon--type_order"
                })
              ],
              1
            )
          ]),
          _c("th", { staticClass: "table-invoice__th" }, [
            _c("div", { staticClass: "table-invoice__info-wrapper" }, [
              _c(
                "div",
                {
                  staticClass:
                    "table-invoice__info-wrapper table-invoice__info-wrapper--pointer",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.changeSort("model")
                    }
                  }
                },
                [
                  _c(
                    "text-bemto",
                    {
                      attrs: {
                        fw: "bold",
                        lh: "small",
                        fs: "xs",
                        color: "black",
                        tag: "p"
                      }
                    },
                    [_vm._v("MODEL")]
                  ),
                  _c("div", {
                    staticClass: "table-invoice__icon icon icon--type_order"
                  })
                ],
                1
              )
            ])
          ]),
          _c("th", { staticClass: "table-invoice__th" }, [
            _c(
              "div",
              {
                staticClass:
                  "table-invoice__info-wrapper table-invoice__info-wrapper--pointer",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeSort("year")
                  }
                }
              },
              [
                _c(
                  "text-bemto",
                  {
                    attrs: {
                      fw: "bold",
                      lh: "small",
                      fs: "xs",
                      color: "black",
                      tag: "p"
                    }
                  },
                  [_vm._v("YEAR")]
                ),
                _c("div", {
                  staticClass: "table-invoice__icon icon icon--type_order"
                })
              ],
              1
            )
          ]),
          _c("th", { staticClass: "table-invoice__th" }, [
            _c(
              "div",
              {
                staticClass:
                  "table-invoice__info-wrapper table-invoice__info-wrapper--pointer"
              },
              [
                _c(
                  "text-bemto",
                  {
                    attrs: {
                      fw: "bold",
                      lh: "small",
                      fs: "xs",
                      color: "black",
                      tag: "p"
                    }
                  },
                  [_vm._v("YEAR PERIOD")]
                )
              ],
              1
            )
          ]),
          _c("th", { staticClass: "table-invoice__th" }, [
            _c(
              "div",
              {
                staticClass:
                  "table-invoice__info-wrapper table-invoice__info-wrapper--pointer"
              },
              [
                _c(
                  "text-bemto",
                  {
                    attrs: {
                      fw: "bold",
                      lh: "small",
                      fs: "xs",
                      color: "black",
                      tag: "p"
                    }
                  },
                  [_vm._v("SERVICE")]
                )
              ],
              1
            )
          ]),
          _c("th", { staticClass: "table-invoice__th" }, [
            _c(
              "div",
              {
                staticClass:
                  "table-invoice__info-wrapper table-invoice__info-wrapper--pointer"
              },
              [
                _c(
                  "text-bemto",
                  {
                    attrs: {
                      fw: "bold",
                      lh: "small",
                      fs: "xs",
                      color: "black",
                      tag: "p"
                    }
                  },
                  [_vm._v("PRICE")]
                )
              ],
              1
            )
          ]),
          _c("th", { staticClass: "table-invoice__th" }, [
            _c(
              "div",
              { staticClass: "table-invoice__info-wrapper" },
              [
                _c(
                  "text-bemto",
                  {
                    attrs: {
                      fw: "bold",
                      lh: "small",
                      fs: "xs",
                      color: "black",
                      tag: "p"
                    }
                  },
                  [_vm._v("REFUSED REQUESTS")]
                )
              ],
              1
            )
          ]),
          _c("th", { staticClass: "table-invoice__th" }, [
            _c(
              "div",
              { staticClass: "table-invoice__info-wrapper" },
              [
                _c(
                  "text-bemto",
                  {
                    attrs: {
                      fw: "bold",
                      lh: "small",
                      fs: "xs",
                      color: "black",
                      tag: "p"
                    }
                  },
                  [_vm._v("PAID REQUESTS")]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "tbody",
        _vm._l(_vm.objectList, function(item, index) {
          return _c("tr", { key: item.id + "/" + index }, [
            _c(
              "td",
              { staticClass: "table-invoice__td" },
              [
                _c(
                  "text-bemto",
                  {
                    attrs: {
                      fw: "medium",
                      lh: "small",
                      fs: "xs",
                      color: "black",
                      tag: "p"
                    }
                  },
                  [_vm._v(_vm._s(item.manufacturer || "-"))]
                )
              ],
              1
            ),
            _c(
              "td",
              { staticClass: "table-invoice__td" },
              [
                _c(
                  "text-bemto",
                  {
                    attrs: {
                      fw: "medium",
                      lh: "small",
                      fs: "xs",
                      color: "black",
                      tag: "p"
                    }
                  },
                  [_vm._v(_vm._s(item.carModel || "-"))]
                )
              ],
              1
            ),
            _c(
              "td",
              { staticClass: "table-invoice__td" },
              [
                _c(
                  "text-bemto",
                  {
                    attrs: {
                      fw: "medium",
                      lh: "small",
                      fs: "xs",
                      color: "black",
                      tag: "p"
                    }
                  },
                  [_vm._v(_vm._s(item.carYear || "-"))]
                )
              ],
              1
            ),
            _c(
              "td",
              { staticClass: "table-invoice__td" },
              [
                _c(
                  "text-bemto",
                  {
                    attrs: {
                      fw: "medium",
                      lh: "small",
                      fs: "xs",
                      color: "black",
                      tag: "p"
                    }
                  },
                  [_vm._v(_vm._s(item.yearPeriod || "-"))]
                )
              ],
              1
            ),
            _c(
              "td",
              { staticClass: "table-invoice__td" },
              [
                _c(
                  "text-bemto",
                  {
                    attrs: {
                      fw: "medium",
                      lh: "small",
                      fs: "xs",
                      color: "black",
                      tag: "p"
                    }
                  },
                  [_vm._v(_vm._s(item.serviceTitle || "-"))]
                )
              ],
              1
            ),
            _c(
              "td",
              { staticClass: "table-invoice__td" },
              [
                _c(
                  "text-bemto",
                  {
                    attrs: {
                      fw: "medium",
                      lh: "small",
                      fs: "xs",
                      color: "black",
                      tag: "p"
                    }
                  },
                  [_vm._v(_vm._s(item.currentPrice || "-"))]
                )
              ],
              1
            ),
            _c(
              "td",
              { staticClass: "table-invoice__td" },
              [
                _c(
                  "text-bemto",
                  {
                    attrs: {
                      fw: "medium",
                      lh: "small",
                      fs: "xs",
                      color: "black",
                      tag: "p"
                    }
                  },
                  [_vm._v(_vm._s(item.countNeg))]
                )
              ],
              1
            ),
            _c(
              "td",
              { staticClass: "table-invoice__td" },
              [
                _c(
                  "text-bemto",
                  {
                    attrs: {
                      fw: "medium",
                      lh: "small",
                      fs: "xs",
                      color: "black",
                      tag: "p"
                    }
                  },
                  [_vm._v(_vm._s(item.countPos))]
                )
              ],
              1
            )
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b7d3b2b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7d3b2b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Tables/OrderStatisticsTable.vue
// module id = 982
// module chunks = 0